import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  
  const toggleDropdown = (dropdown: string) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      {/* Top Banner */}
      <div className="bg-emerald-600 text-white text-center py-2">
        <div className="text-sm font-medium">FREE ESTIMATES & ENERGY ASSESSMENTS!</div>
      </div>
      
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <a href="/" className="flex items-center space-x-2">
            <h1>
              <img 
                src="https://static.readdy.ai/image/4e26ad7192bd77d86f80f09d990bed83/f48196d81798c2f07d880df7a7c3ee26.png" 
                alt="Eco Loft Insulation Installers Coventry" 
                title="Eco Loft Insulation Installers - Coventry loft insulation specialists"
                className="h-12 w-auto"
              />
            </h1>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <div className="relative">
              <button 
                className="flex items-center space-x-1 text-gray-700 hover:text-emerald-600 transition-colors"
                onClick={() => toggleDropdown('services')}
              >
                <span>Services</span>
                <i className="ri-arrow-down-s-line"></i>
              </button>
              {activeDropdown === 'services' && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-white shadow-xl rounded-lg border z-50">
                  <div className="py-2">
                    <a href="/services/loft-insulation" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600">Loft Insulation Installation</a>
                    <a href="/services/loft-boarding" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600">Loft Boarding</a>
                    <a href="/services/spray-foam-removal" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600">Spray Foam Removal</a>
                    <a href="/services" className="block px-4 py-2 text-emerald-600 font-medium hover:bg-emerald-50">View All Services</a>
                  </div>
                </div>
              )}
            </div>
            <a href="/process" className="text-gray-700 hover:text-emerald-600 transition-colors">Our Process</a>
            <a href="/gallery" className="text-gray-700 hover:text-emerald-600 transition-colors">Gallery</a>
            <a href="/areas" className="text-gray-700 hover:text-emerald-600 transition-colors">Areas We Serve</a>
            <div className="relative">
              <button 
                className="flex items-center space-x-1 text-gray-700 hover:text-emerald-600 transition-colors"
                onClick={() => toggleDropdown('about')}
              >
                <span>About</span>
                <i className="ri-arrow-down-s-line"></i>
              </button>
              {activeDropdown === 'about' && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-xl rounded-lg border z-50">
                  <div className="py-2">
                    <a href="/about" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600">About Company</a>
                    <a href="/reviews" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600">Customer Reviews</a>
                    <a href="/contact" className="block px-4 py-2 text-gray-700 hover:bg-emerald-50 hover:text-emerald-600">Contact Us</a>
                  </div>
                </div>
              )}
            </div>
          </nav>

          {/* Contact Info & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <a 
              href="tel:+442476070153" 
              className="inline-flex items-center justify-center px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              024 7607 0153
            </a>
            <Button href="/estimate">Get Free Estimate</Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center space-x-4">
            <a href="tel:+442476070153" className="text-emerald-600">
              <i className="ri-phone-line text-xl"></i>
            </a>
            <button onClick={toggleMenu} className="text-gray-700">
              <div className="w-6 h-6 flex flex-col justify-center space-y-1">
                <div className={`h-0.5 bg-current transition-all ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></div>
                <div className={`h-0.5 bg-current transition-all ${isMenuOpen ? 'opacity-0' : ''}`}></div>
                <div className={`h-0.5 bg-current transition-all ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></div>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4">
            <nav className="space-y-4">
              <a href="/services" className="block text-gray-700 hover:text-emerald-600">Services</a>
              <a href="/process" className="block text-gray-700 hover:text-emerald-600">Our Process</a>
              <a href="/gallery" className="block text-gray-700 hover:text-emerald-600">Gallery</a>
              <a href="/areas" className="block text-gray-700 hover:text-emerald-600">Areas We Serve</a>
              <a href="/about" className="block text-gray-700 hover:text-emerald-600">About</a>
              <Button href="/estimate" className="w-full mt-4">Get Free Estimate</Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
